export const hardSkills = () =>
{
    return [
        {
            name: "Programación",
            skills:
                [
                    {name: "PHP",img: "354180/php",value: 90,show: true},
                    {name: "C#",img: "353622/c-sharp",value: 90,show: true},
                    {name: "Java",img: "303388/java-4-logo",value: 80,show: true},
                    // { name: "Dart", img: "353631/dart", value: 100, show:true},
                    {name: "Python",img: "452091/python",value: 80,show: true}
                ]
        },
        {
            name: "Frontend",
            skills:
                [
                    {name: "Html",img: "353884/html-5",value: 90,show: true},
                    {name: "Css",img: "353623/css-3",value: 80,show: true},
                    {name: "JavaScript",img: "452045/js",value: 90,show: true},
                    {name: "JQuery",img: "353940/jquery",value: 90,show: true},
                    {name: "Bootstrap",img: "353498/bootstrap",value: 90,show: true},
                ]
        },
        {
            name: "Frameworks",
            skills:
                [
                    {name: "Laravel",img: "353985/laravel",value: 90,show: true},
                    {name: "Vue",img: "452130/vue",value: 95,show: true},
                    {name: "Angular",img: "452156/angular",value: 70,show: true},
                    {name: "ASP.Net",img: "305969/dot-net",value: 70,show: true},
                ]
        },
        {
            name: "Móvil",
            skills:
                [
                    {name: "Flutter",img: "353751/flutter",value: 70,show: true},
                    {name: "Xamarin",img: "354576/xamarin",value: 75,show: true},
                    {name: "Kotlin",img: "373728/kotlin",value: 70,show: true},
                ]
        },
        {
            name: "DB",
            skills:
                [
                    {name: "MySql",img: "342053/mysql",value: 85,show: true},
                    {name: "SQL Server",img: "473725/microsoftsqlserver",value: 80,show: true},
                    {name: "Firebird",img: "443058/brand-firebird",value: 80,show: true},
                    {name: "SQLite",img: "374094/sqlite",value: 75,show: true},
                ]
        },
        {
            name: "Desktop",
            skills:
                [
                    {name: "Windows Forms",img: "382713/windows-applications",value: 85,show: true},
                    {name: "WPF",img: "349566/windows",value: 85,show: true},
                    {name: "Electron",img: "378796/electron",value: 85,show: true},
                ]
        },
        {
            name: "Control de Versiones",
            skills:
                [
                    {name: "Git",img: "452210/git",value: 85,show: true},
                    {name: "GitHub",img: "503359/github",value: 85,show: true},
                    {name: "GitLab",img: "448226/gitlab",value: 85,show: true},
                ]
        },
        {
            name: "Plataformas",
            skills:
                [
                    {name: "Linux",img: "448236/linux",value: 90,show: true},
                    {name: "Windows",img: "382713/windows-applications",value: 90,show: true},
                    {name: "Virtualización",img: "499822/virtual-device",value: 90,show: true},
                ]
        },
        {
            name: "Servidores",
            skills:
                [
                    {name: "Nginx",img: "303554/nginx-logo",value: 85,show: true},
                    {name: "Apache",img: "353400/apache",value: 80,show: true},
                    {name: "IIS",img: "331786/windows-azure",value: 80,show: true},
                ]
        },
        // {
        //     name: "Software",
        //     skills:
        //         [
        //             {name: "VSCode",img: "374173/vscode3",value: 90,show: true},
        //             {name: "Visual Studio",img: "354520/visual-studio",value: 85,show: true},
        //             {name: "Office",img: "448239/microsoft",value: 90,show: true},
        //             {name: "Figma",img: "448222/figma",value: 85,show: true},
        //             {name: "Photoshop",img: "373968/photoshop",value: 80,show: true},
        //         ]
        // },
        {
            name: "Web",
            skills:
                [
                    {name: "Trello",img: "354463/trello",value: 90,show: true},
                    {name: "Notion",img: "521773/notion",value: 90,show: true},
                    {name: "Slack",img: "452102/slack",value: 85,show: true},
                ]
        },
        {
            name: "Aprendiendo",
            skills:
                [
                    {name: "IA",img: "337224/robot-one",value: 20,show: true},
                    // // {name: "Docker",img: "354926/docker",value: 40,show: true},
                    {name: "Web Security",img: "485059/security-shield",value: 20,show: true},
                    // {name: "Markdown",img: "369410/markdown",value: 40,show: true},
                    {name: "AWS",img: "448266/aws",value: 20,show: true},
                ]
        },
        {
            name: "Por Aprender",
            skills:
                [
                    {name: "NoSQL",img: "468484/database-2",value: 0,show: true},
                    {name: "CI/CD",img: "387298/cycle-arrow",value: 0,show: true},
                    {name: "UI/UX",img: "492608/design",value: 0,show: true},
                ]
        },
    ]
}

export const softskills = () =>
{
    return [
        "Adaptabilidad al cambio",
        "Colaboración",
        "Comunicación",
        "Empatía",
        "Ética laboral",
        "Inteligencia emocional",
        "Organización",
        "Orientación a resultados",
        "Resolución de Problemas",
        "Trabajo en Equipo",
        "Proactividad",
        "Toma de decisiones",
    ]
}

export const courses = () =>
{
    return [
        "Administración de Servidores Linux",
        "Angular: De cero a experto",
        "Docker - Guía práctica de uso para desarrolladores",
        "Flutter Guía completa de desarrollo para IOS y Android",
        "JavaScript Moderno Guía para dominar el lenguaje",
        "Principios SOLID y Clean Code",
        "Vue.js De cero a experto",
    ]
}

export const certifications = () =>
{
    return [
        "Microsoft Office Excel",
        "Microsoft Office Word",
    ]
}

export const education = () =>
{
    return [
        {
            institute: "Especialización Frontend - Oracle Next Education",
            period: "2023",
            certificate: "",
        },
        {
            institute: "Tecnológico Nacional de México/ Instituto Tecnológico de Tehuacán",
            period: "2015 - 2019",
            certificate: "Ing. Sistemas Computacionales",
        },
        {
            institute: "Colegio de Educación Profesional Técnica del Edo. De Puebla 150",
            period: "2012 - 2015",
            certificate: "PTB. Mtto. De Equipo de Cómputo",
        },
    ]
}

export const professional = () =>
{
    return [
        {
            job: "Ingeniero de Desarrollo",
            period: "2023 - Actualidad",
            company: "Del Bravo Tech",
            achievements: [
                "Sistema para control de certificaciones",
                "Portal de conciliación de facturas",
                "Sistema acortador de enlaces",
            ]
        },
        {
            job: "Desarrollador",
            period: "2021 - 2023",
            company: "Conserflow",
            achievements: [
                "Software para monitoreo de casetas de central térmica",
                "Aplicación móvil para el departamento de Almacén",
                "Creación de portal de proveedores",
                "Desarrollo del Sistema Conserflow - ERP",
            ]
        },
        {
            job: "Analista de TI",
            period: "2020 - 2021",
            company: "Conserflow",
            achievements: [
                "Desarrollo de software para la trazabilidad de spools versión Móvil",
                "Gestor de correos para respaldo de documentos",
                "Mantenimiento preventio y correctivo a equipos de cómputo e impresión",
                // "Soporte a usuarios para uso del Sistema Conserflow",
            ]
        },
        // {
        //     job: "Residencia Profesional",
        //     period: "2019",
        //     company: "Conserflow SA. de CV.",
        //     achievements: [
        //         "Automatizar la generación de reportes de Montaje de Instrumentos Eléctricos",
        //         "Automatizar la generación de reportes de Recepción de Materiales del Proveedor",
        //         "Automatizar la generación de reportes de Recepción de Materiales Propiedad del Cliente",
        //         "Desarrollo de Software para la Trazabilidad de Spools versión Escritorio",
        //     ]
        // },
    ]
}

export const projects = () =>
{
    return [
        {
            id: 1,
            name: "Panel Admin",
            description: "Panel Admin es un la parte FrontEnd de un panel de administración, desarrollado en Vue 3, basado en CoreUI v4.",
            category: "web",
            tags: ["vue","js","css","html"],
            public: true,
            chars: ["Vue 3","Vuex","Desarrollo por módulos","Rutas autenticadas","No autenticadas"],
            url_repo: "https://github.com/larh1/panel_admin_vue3",
            url_demo: "https://paneladmin.larh.dev",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/222923256-7f57e58b-9d24-4f02-a6e6-7db95b2e75c7.png",
                    "https://user-images.githubusercontent.com/42705449/222923698-0617d371-2b58-45fa-a446-cd7705c88675.png",
                    "https://user-images.githubusercontent.com/42705449/222923767-23fc7188-32d9-478a-aa74-aa3471d91a4b.png",
                    "https://user-images.githubusercontent.com/42705449/223197021-707bc0fb-8eae-4325-986e-1486e3fba0de.png",
                    "https://user-images.githubusercontent.com/42705449/223197203-444f2438-7cc4-46e1-96a2-2b055aa8793e.png",
                    "https://user-images.githubusercontent.com/42705449/223197598-223d3854-271a-416b-8234-e67cd9efd46c.png",
                ],
        },
        {
            id: 2,
            name: "Trazabilidad Desktop",
            description: "Aplicación de escritorio para trazabilidad de spools, para la empresa Conserflow",
            category: "desktop",
            tags: ["windows","wpf","c#","sql server"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229186602-5d32a8a3-1e7c-447c-b0cb-95fb3638eda1.png",
                    "https://user-images.githubusercontent.com/42705449/229187091-beb9da8a-7bd9-4b6b-914e-ad9fdd190803.png",
                    "https://user-images.githubusercontent.com/42705449/229187140-3c8d29f8-cbeb-4061-8d23-0be54e4205f2.png",
                ],
        },
        {
            id: 3,
            name: "Tic Tac Toe",
            description: "Tic Tac Toe es una adaptación web del popular juego Tres en Raya (también llamado Tres en línea, Juego del Gato, Ceros y Cruces) para dos jugadores, realizado con Laravel y Vue.",
            category: "web",
            tags: ["laravel","html","php","vue","css"],
            public: true,
            chars: ["dos jugadores","pista de celda","Vista para móviles","Comprobante de victoria"],
            url_repo: "https://github.com/larh1/gato",
            url_demo: "https://gato.larh.dev/",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229302040-7b91cfe2-d166-45d9-9b90-f1447b76d4ae.jpg",
                    "https://user-images.githubusercontent.com/42705449/229302049-a9120a30-c436-4b71-9a1a-b8e109f8be38.png",
                    "https://user-images.githubusercontent.com/42705449/229302052-72c143ed-3c10-4db0-bd15-1d648579dfaa.png",
                    "https://user-images.githubusercontent.com/42705449/223861883-ae5db94f-fa8b-468a-9437-93ac798015ed.png",
                    "https://user-images.githubusercontent.com/42705449/229302060-c0be246d-dc1c-42aa-b7a0-831be9907499.png",
                    "https://user-images.githubusercontent.com/42705449/223862606-fa7691e4-6bbf-43c4-a2f7-1d46458b8f4b.png",
                ],
        },
        {
            id: 4,
            name: "Weather App",
            description: "Una Web App para consultar el clima.",
            category: "web",
            tags: ["php","js","laravel","bootstrap"],
            public: true,
            chars: ["Búsqueda de ciudades","Mapa de la ciudad","Pronóstico por hora","Consulta del clima en la ciudad actual"],
            url_repo: "https://github.com/larh1/weather_app",
            url_demo: "https://weather.larh.dev/",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/228089668-4742c450-a67d-4f4a-bb53-83efb9a32fc4.png",
                    "https://user-images.githubusercontent.com/42705449/228089722-0a6cb313-70b6-408a-ace6-610b563782ec.png",
                    "https://user-images.githubusercontent.com/42705449/228089767-09dcbebd-2a39-4313-a20d-a1fef0d9d658.png",
                    "https://user-images.githubusercontent.com/42705449/228089821-278f7052-e42a-42b8-a047-0c1f6619e2fe.png",
                    "https://user-images.githubusercontent.com/42705449/228089915-f74e7b41-50eb-4ff8-bb02-f5ae56cb8b53.png",
                ],
        },
        {
            id: 5,
            name: "¿Quién es ese Pokemon?",
            description: "Pon a prueba tus conocimientos y descubre quién es ese Pokemon.",
            category: "web",
            tags: ["vue","html","js","css"],
            public: true,
            chars: ["Vue 3","+900 Pokemon","pruebas unitarias"],
            url_repo: "https://github.com/larh1/pokemon_game",
            url_demo: "https://pokemon.larh.dev/",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/224390345-3c4cf80b-9c62-402e-8511-3bb58dbcb7f4.png",
                    "https://user-images.githubusercontent.com/42705449/224391179-c7974b69-b7cd-4b09-881f-4d1921e0de8c.png",
                ],
        },
        {
            id: 17,
            name: "Sistema Conserflow",
            description: "Sistema de automatización de procesos administrativos ERP",
            category: "web",
            tags: ["vue","laravel","js","html"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229602560-c7579fd8-1691-4f02-993c-89e1d1ec7d8c.png",
                ],
        },
        {
            id: 6,
            name: "Journal App",
            description: "Journal App es una aplicación web para el registro de notas.",
            category: "web",
            tags: ["vue","js","firebase","html","css"],
            public: true,
            chars: ["Registro, búsqueda, actualización, eliminación","Almacenamiento en Firebase","Registro de usuarios","Búsqueda por contenido"],
            url_repo: "https://github.com/larh1/journal_app/",
            url_demo: "https://journal.larh.dev/",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/224504386-0f58a3db-0ff7-49fd-bb1e-0df1bd3a2d73.png",
                    "https://user-images.githubusercontent.com/42705449/224504415-1e9be290-40ec-4eb8-9033-732d3a8cc19c.png",
                    "https://user-images.githubusercontent.com/42705449/224504464-77282b94-6d95-4fbb-84e8-a00139a46bc4.png",
                    "https://user-images.githubusercontent.com/42705449/224504730-e2693795-e280-42c0-93dd-be5c3b5abb84.png",
                ],
        },
        {
            id: 7,
            name: "GifHub",
            description: "Buscador de gifs, desarrollado en Angular",
            category: "web",
            tags: ["angular","js","css","html"],
            public: true,
            chars: ["Búsqueda de gifs","historial de búsqueda"],
            url_repo: "https://github.com/larh1/angular_gifs",
            url_demo: "https://gifhub.larh.dev/",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/225103060-622205b9-7a2a-4a79-acfe-c95e93d26edd.png",
                    "https://user-images.githubusercontent.com/42705449/225103380-7dc52659-69bf-4f55-adeb-8e1f6222fdf1.png",
                ],
        },
        {
            id: 8,
            name: "App Almacén",
            description: "Aplicación móvil para el departamento de Almacén, de la empresa Conserflow S.A de C.V",
            category: "movil",
            tags: ["xamarin","android","c#","xml"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229302682-cce0b4b8-9810-4561-a1d9-e579374ebfb0.jpeg",
                    "https://user-images.githubusercontent.com/42705449/229302688-a74e644e-c398-4ef8-9955-2c79e1ae37ba.jpg",
                    "https://user-images.githubusercontent.com/42705449/229302689-a841930b-d81c-4222-af6a-c3565f721048.jpeg",
                    "https://user-images.githubusercontent.com/42705449/229302692-3daa0aa3-38b4-4055-8575-dd2578ab0e6a.jpeg",
                ],
        },
        {
            id: 9,
            name: "Project Tracker",
            description: "Project Tracking es una web para dar seguimiento a proyectos, control de avances y revisión de pagos.",
            category: "web",
            tags: ["laravel","js","html","css"],
            public: false,
            chars: [],
            url_repo: "https://github.com/larh1/project_tracker",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/226066385-b236302b-3b96-4024-90aa-e16ac1e09ad0.png",
                    "https://user-images.githubusercontent.com/42705449/226066575-eefa7c47-b429-4354-9e4b-18f4e0720f58.png",
                    "https://user-images.githubusercontent.com/42705449/226066633-4a0547d0-3750-4422-acad-5eaa634b74b7.png",
                    "https://user-images.githubusercontent.com/42705449/226066692-fc29bb50-3301-457f-8961-18135c269790.png",
                    "https://user-images.githubusercontent.com/42705449/226066888-0671b0a4-694c-46d7-8037-202fa2beacf9.png",
                ],
        },
        {
            id: 10,
            name: "Monitoreo Central térmica",
            description: "Software para monitoreo de casetas de la Central Térmica del Valle de México.",
            category: "web",
            tags: ["php","js","html","bootstrap"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/225751974-2ce5870f-4be9-4f31-9a16-1a2c63fd052c.png",
                ],
        },
        {
            id: 11,
            name: "Checador Windows",
            description: "Checador de asistencia para equipos windows",
            category: "desktop",
            tags: ["windows","c#","mysql"],
            public: false,
            chars: ["Para equipos windows","Checador por QR","Generación de reportes"],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229182572-4481ae54-158c-4d77-a1b9-519f8948c6a6.jpg",
                    "https://user-images.githubusercontent.com/42705449/229182609-735311df-4c5f-47bf-9374-16d030209af3.png",
                    "https://user-images.githubusercontent.com/42705449/229182620-a5e92d8f-601d-4972-a086-624363668f78.png",
                    "https://user-images.githubusercontent.com/42705449/229182634-93997a20-351b-418a-9302-340d6779a7d8.png",
                ],
        },
        {
            id: 12,
            name: "Portal Proveedores",
            description: "Portal para programación de pagos de proveedores, de la empresa Conserflow S.A de C.V",
            category: "web",
            tags: ["php","bootstrap","ajax","css"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/225986937-1c30c94f-b470-4cbd-a74e-418e3b21f8df.png",
                    "https://user-images.githubusercontent.com/42705449/225987102-97243db6-47ed-4755-a64c-53c4b1525234.png",
                    "https://user-images.githubusercontent.com/42705449/229211067-e08d7ea0-3672-4644-8395-a54419e89167.jpg",
                ],
        },
        {
            id: 13,
            name: "Trazabilidad Móvil",
            description: "Aplicación móvil para trazabilidad de spools, para la empresa Conserflow S.A de C.V",
            category: "movil",
            tags: ["xamarin","android","c#","sql server"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229184892-a86d4d46-2840-4c76-b0a8-78c7b08f3793.png",
                    "https://user-images.githubusercontent.com/42705449/229184919-ac30a128-4c8e-4df8-abd3-4f1373fa1c64.png",
                    "https://user-images.githubusercontent.com/42705449/229184962-b7f25dc5-da7e-48d7-acb7-4318cd9e1543.png",
                    "https://user-images.githubusercontent.com/42705449/229184978-e9697055-686d-459d-8297-5d7831c2c99f.png",
                    "https://user-images.githubusercontent.com/42705449/229185030-1bd056ce-8c2d-4a82-9794-8bc3ce2cc60e.png",
                ],
        },
        {
            id: 14,
            name: "Usb Block",
            description: "Control de accciones para unidades USB",
            category: "desktop",
            tags: ["windows","c#"],
            public: false,
            chars: ["Modo solo lectura","Modo Lectura-Escritura","deshabilitar usb"],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229187517-d9607aa4-687b-4d86-b2f1-8442958f5da1.png",
                    "https://user-images.githubusercontent.com/42705449/229187531-72420507-d1f6-40ad-82e7-a2822ac54598.png",
                    "https://user-images.githubusercontent.com/42705449/229187542-15f3b20b-d26d-443c-b6b6-865339d64cb1.png",
                    "https://user-images.githubusercontent.com/42705449/229187575-84306ca5-af7d-49b3-8653-ca7633a34dac.png",

                ],
        },
        {
            id: 17,
            name: "Desarrollo de Emociones",
            description: "Material didáctico para el desarrollo de las dimensiones socioemocionales",
            category: "desktop",
            tags: ["windows","wpf","c#"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229189576-82f8293d-18c5-40f8-afcd-992abcdc8aea.png",
                    "https://user-images.githubusercontent.com/42705449/229189582-6932788c-2606-4e94-bd11-31999fa19d6b.png",
                    "https://user-images.githubusercontent.com/42705449/229189597-29559bff-19a2-482b-9405-9b59f59ce53c.png",
                ],
        },
        {
            id: 16,
            name: "Control de Inventario",
            description: "Sistema de de inventario para control de productos, categorías y ventas",
            category: "web",
            tags: ["php","mysql","bootstrap","js"],
            public: false,
            chars: ["dashboard","usuarios","catálogo de productos","categorías","ventas"],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://user-images.githubusercontent.com/42705449/229190588-dda684d3-f02c-41d2-8ed3-48f947a645e1.png",
                    "https://user-images.githubusercontent.com/42705449/229190604-7556709b-148f-425c-a8cd-10ccb7961b01.png",
                    "https://user-images.githubusercontent.com/42705449/229190621-9457b6ec-829a-49d4-9a7b-82c9cf54248e.png",
                    "https://user-images.githubusercontent.com/42705449/229190632-ed1664d1-e2a2-4a55-ae81-637e25eecbb4.png",
                    "https://user-images.githubusercontent.com/42705449/229190638-f1e35a3f-8d03-43c2-a17e-43772d2be925.png",
                ],
        },
        {
            id: 18,
            name: "Tarjeta de Presentación",
            description: "Tarjetas digitales de presentación profesional y contacto",
            category: "web",
            tags: ["php","mysql","bootstrap","vue"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://github-production-user-asset-6210df.s3.amazonaws.com/42705449/402196917-fcf362e3-fe78-4045-8997-c64f984dc7ba.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAVCODYLSA53PQK4ZA%2F20250111%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250111T033110Z&X-Amz-Expires=300&X-Amz-Signature=701324333dc463c511bcac359862a21b3ee73b7f9b6e8cd90790097dabb1d92b&X-Amz-SignedHeaders=host"
                ],
        },
        {
            id: 19,
            name: "Control de Requisiciones",
            description: "Sistema para el control y gestión de requisiciones de materiales, seguimiento, aprobación y control de documentos.",
            category: "web",
            tags: ["laravel","vue","mysql","bootstrap"],
            public: false,
            chars: [],
            url_repo: "",
            url_demo: "",
            images:
                [
                    "https://github.com/user-attachments/assets/ac9e5ccd-544c-478c-ac31-32febf864887"
                ],
        },
    ]
}

export const info = () =>
{
    return [
        [
            {field: "Nacimiento",value: "21 Agosto 1997",type: 1},
            {field: "Ciudad",value: "Tehuacán, Puebla",type: 1},
            {field: "País",value: "México",type: 1},
        ],
        [
            {field: "Título",value: "Ing. Sistemas Computacionales",type: 1},
            {field: "Linkedin",text: "larh1",value: "https://www.linkedin.com/in/larh1/",type: 2,},
            {field: "Github",text: "larh1",value: "https://github.com/larh1",type: 2,},
        ],
    ]
}

export const contact = () =>
{
    return [
        {name: "Github",value: "https://github.com/larh1/",picture: "https://www.svgrepo.com/show/512317/github-142.svg"},
        {name: "linkedin",value: "https://www.linkedin.com/in/larh1/",picture: "https://www.svgrepo.com/show/448234/linkedin.svg"},
    ]
}

export const emailConfig = () =>
{
    const data =
    {
        service_id: "service_ldr69ux",
        template: "template_76dz556",
        user_id: "JXfYGM8ug29fYgaTJ",
    }
    return data
}

export const getProjectById = (id) => projects().find(p => p.id == id)

export default hardSkills;